import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';

export enum DeviceUPSControlActionTypes {
  GetUPSControlStatus = '[Device] Get UPS Control Status',
  UpsertUPSControlStatus = '[Device] Upsert UPS Control Status',
  GetUPSControlStatusFail = '[Device] Get UPS Control Status Fail',
  ExecuteUPSControl = '[Device] Execute UPS Control',
  ExecuteUPSControlSuccess = '[Device] Execute UPS Control Success',
  ExecuteUPSControlFail = '[Device] Execute UPS Control Fail',
}

export class GetUPSControlStatus implements Action {
  readonly type = DeviceUPSControlActionTypes.GetUPSControlStatus;

  constructor(public payload:  any = null) {}
}

export class UpsertUPSControlStatus implements Action {
  readonly type = DeviceUPSControlActionTypes.UpsertUPSControlStatus;

  constructor(public payload:  any = null) {}
}

export class GetUPSControlStatusFail {
  readonly type = DeviceUPSControlActionTypes.GetUPSControlStatusFail;
  
}

export class ExecuteUPSControl implements Action {
  readonly type = DeviceUPSControlActionTypes.ExecuteUPSControl;

  constructor(public payload:  any = null) {}
}

export class ExecuteUPSControlSuccess implements Action {
  readonly type = DeviceUPSControlActionTypes.ExecuteUPSControlSuccess;

  constructor(public payload:  any = null) {}
}

export class ExecuteUPSControlFail implements Action {
  readonly type = DeviceUPSControlActionTypes.ExecuteUPSControlFail;

  constructor(public payload:  any = null) {}
}

export type DeviceUPSControlActions =
GetUPSControlStatus
 | UpsertUPSControlStatus
 | GetUPSControlStatusFail
 | ExecuteUPSControl
 | ExecuteUPSControlSuccess
 | ExecuteUPSControlFail;
